// MarieIcon — cursive "M" rendered in Dancing Script.
// Drop-in size-compatible replacement for MUI icon usage.
// fontSize prop mirrors MUI icon fontSize (number = px).
// If color is omitted, falls back to theme primary.main.

import { useTheme } from "@mui/material";

interface MarieIconProps {
  fontSize?: number;
  color?: string;
}

export function MarieIcon({ fontSize = 18, color }: MarieIconProps) {
  const theme = useTheme();
  const resolvedColor = color ?? theme.palette.primary.main;

  return (
    <span
      style={{
        fontFamily: "'Dancing Script', cursive",
        fontSize: fontSize * 1.4,
        fontWeight: 600,
        color: resolvedColor,
        lineHeight: 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        flexShrink: 0,
      }}
    >
      M
    </span>
  );
}
